import ContentLibraryMessageForm from './ContentLibraryMessageForm';
export default ContentLibraryMessageForm;
